import * as React from "react";
import { useEffect, useReducer, useRef, useState } from 'react';
import { Spinner, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from 'reactstrap';
import InfiniteScroll from 'react-infinite-scroller';
import * as Models from '../models';
import classnames from 'classnames';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons"
import { InvestorNewsService } from "../services/InvestorNewsService";

const PAGE_SIZE = 10;

type Props = {
    listingHeader?: string;
    active?: boolean;
    path: string;
}
type InvestorNewsPageState = {
    keywords: string;
    canLoadMore: boolean;
    isLoading: boolean;
    items: Models.ResourceItem[];
    totalItems: number;
    searchTrigger: number;
}

const initialState: InvestorNewsPageState = {
    keywords: '',
    canLoadMore: false,
    isLoading: false,
    items: [],
    totalItems: 0,
    searchTrigger: 0
}


const InvestorNewsPage = (props: Props) => {

    const getInitialState = () => {
        let result = initialState;

        return result;
    };

    const [state, setState] = useReducer(
        (prevState: InvestorNewsPageState, newState: Partial<InvestorNewsPageState>) => ({ ...prevState, ...newState }),
        getInitialState()
    );

    const search = async () => {

        setState({
            isLoading: true
        });

        const result = await InvestorNewsService.search({ keywords: state.keywords }, PAGE_SIZE, 0);

        if (!result.hasErrors) {
            setState({
                items: result.value.items,
                totalItems: result.value.totalItems,
                isLoading: false,
                canLoadMore: result.value.moreItems
            })
        }
    }

    const loadMore = async () => {

        setState({
            isLoading: true
        });

        const result = await InvestorNewsService.search({ keywords: state.keywords }, PAGE_SIZE, state.items.length);

        if (!result.hasErrors) {

            const newItemsSet = state.items.concat(result.value.items);

            setState({
                items: newItemsSet,
                totalItems: result.value.totalItems,
                isLoading: false,
                canLoadMore: result.value.moreItems
            })
        }

    }

    useEffect(() => {

        if (props.active)
            search();

    }, [props.active]);

    return (
        <>
            {/*<div className="container mb-3">
                <div className="row align-items-end listing-filters">
                    <div className="col-lg-6 col-md-6 col-sm-12 pe-0 mb-3">
                        <div className="form-group">
                            <label>Search</label>
                            <input type="text" onChange={(e) => { setState({ keywords: e.target.value }) }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        search();
                                    }
                                }}
                                placeholder="Keywords Search" className="form-control" /></div>
                    </div>
                    <div className="col-auto col-xs-12 mb-3 pe-0">
                        <div className="form-group mt-lg-3" ><button type="button" className="btn btn-primary d-block w-100" onClick={search}>Search</button></div>
                    </div>
                </div>
            </div>*/}

            <div className="bg-white pb-1 pt-3 news-section">
                <div className="container">
                    {props.listingHeader && <div className="row">
                        <div className="col">
                            <h3 className="my-3">{props.listingHeader}</h3>
                        </div>
                    </div>}
                    <div className="row">
                        <div className="col">
                            <table className="table">
                                <InfiniteScroll
                                    pageStart={0}
                                    loadMore={loadMore}
                                    hasMore={state.canLoadMore && !state.isLoading && props.active}
                                    useWindow={true}
                                    element="tbody"
                                >
                                    {state.items.map(item => {

                                        return <tr key={item.nodeId}>
                                            <td>
                                                <a href={item.url}>
                                                    <h5 className="title" dangerouslySetInnerHTML={{ __html: item.title }}></h5>
                                                </a>
                                            </td>
                                            <td className="text-nowrap date-cell">
                                                <div>{item.date}</div>
                                            </td>
                                        </tr>
                                    })}
                                </InfiniteScroll>
                            </table>
                            {!state.isLoading && state.items.length == 0 && <div className="listing-no-items-found">
                                Sorry.  There are no items matching your search criteria.
                    </div>}
                            <div className="text-center" style={{
                                marginTop: "-12px",
                                height: "45px"
                            }}>
                                {state.isLoading &&
                                    <Spinner color="primary" />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default InvestorNewsPage;